import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon/portrait.png'


const _withScopeId = n => (_pushScopeId("data-v-108bf127"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toBar" }
const _hoisted_2 = {
  class: "el-dropdown-link",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  src: _imports_0,
  alt: "",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_5 = {
  class: "header-dropdown__name",
  style: {"display":"flex","align-items":"center"}
}

import { getCurrentInstance, ref, onMounted } from 'vue'
import { ArrowDown, EditPen, Back, Bell } from '@element-plus/icons-vue'
import { logout, getInfo, getTokenCode } from '@/api/auth'
import { useMainStore } from '@/stores/main'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { storage } from '@/utils/tool'
import { messageList } from '@/api/message'
import messageListDrawer from './messageListDrawer.vue'
import { hasPermission } from '@/utils/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'userbar',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const { t } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
const router = useRouter()
const store = useMainStore()
const fileUrl = process.env.VUE_APP_OSS_ENDPOINT

// 语言切换
const lang = ref('')
const onChangeLang = (value: string) => {
  lang.value = value
  proxy.$i18n.locale = value
  storage.setItem('LANG', value)
  console.log('value-lang', value)
  location.reload()
}
const onPushOld = () => {
  getTokenCode().then((res: any) => {
    if (res.code === 110200) {
      window.location.href = `${process.env.VUE_APP_OLD_VERSION_URL}?_tokenCode=${res.result}`
    } else {
      ElMessage.error(res.msg)
    }
  })
}
// 用户信息
const userName = ref('')
const userAvatar = ref('')

// 操作
const handleUser = (command: string) => {
  // 退出
  if (command === 'outLogin') {
    proxy
      .$confirm(t('header.exitText'), t('common.tips'), {
        type: 'warning',
        confirmButtonText: t('header.exit'),
        cancelButtonText: t('common.Cancel')
      })
      .then(() => {
        logout().then((res: any) => {
          if (res.code === 100200) {
            storage.removeItem('TOKEN')
            storage.removeItem('TOKEN_INSPECT')
            storage.removeItem('TOKEN_CLOUD') // 保留一段时间删除 todo 重构java
            storage.removeItem('USER_INFO') // 保留一段时间删除 todo
            ElMessage.success(t('login.logoutSuccess'))
            router.push({ path: '/login' })
            window.localStorage.removeItem('active') // 保留一段时间删除 todo
          }
        })
      })
      .catch(() => {
        // 取消退出
      })
  } else if (command === 'user') {
    router.push({
      path: '/myProfile'
    })
  }
}
// 无个人信息，接口查询
const onGetMeInfo = async () => {
  await getInfo().then((res: any) => {
    if (res.code === 100200) {
      store.userInfo = res.result
      userName.value = res.result.username || ''
      userAvatar.value = res.result.avatar ? fileUrl + res.result.avatar : ''
    }
  })
}
onMounted(() => {
  lang.value = (window as any).localStorage.getItem('LANG') || proxy.$config.LANG
  // 用户信息
  const userData: any = store.userInfo
  if (!userData || !userData.id) {
    onGetMeInfo()
  } else {
    userName.value = userData && userData.username ? userData.username : ''
    userAvatar.value = userData && userData.avatar ? fileUrl + userData.avatar : ''
  }
})
// 消息
// 获取消息列表
const messageVal = ref(0)

const getMessageList = () => {
  const data = {
    keywords: '',
    isDeal: -1,
    pageNum: 1,
    pageSize: 100,
    createdAtStart: '',
    createdAtEnd: ''
  }
  messageList(data).then(res => {
    if (res.code === 100200) {
      messageVal.value = res.resultSize
    } else {
      ElMessage.error(res.msg)
    }
  })
}

const messageListDrawerRef: any = ref('')
const messageListClick = () => {
  messageListDrawerRef.value.drawer = true
  messageListDrawerRef.value.getMessageInfo()
}
onMounted(() => {
  getMessageList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(hasPermission)('inspect.header.oldVersion'))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            plain: "",
            onClick: onPushOld,
            class: "oldVersion-btn"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('header.oldVersion')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("span", null, [
        (messageVal.value)
          ? (_openBlock(), _createBlock(_component_el_badge, {
              key: 0,
              value: messageVal.value,
              class: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _unref(Bell),
                  onClick: messageListClick,
                  circle: ""
                }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["value"]))
          : (_openBlock(), _createBlock(_component_el_badge, {
              key: 1,
              class: "item"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: _unref(Bell),
                  onClick: messageListClick,
                  circle: ""
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
      ]),
      _createVNode(_component_el_dropdown, {
        size: "large",
        class: "icon__lang"
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onChangeLang('zh_CN')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("简体中文")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onChangeLang('en')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("English")
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onChangeLang('fr')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Français")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(lang.value === 'en' ? 'EN' : lang.value === 'fr' ? 'FR' : '中') + " ", 1),
            _createVNode(_component_el_icon, {
              class: "el-icon--right",
              style: {"color":"#000"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowDown))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      (userAvatar.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: userAvatar.value,
            alt: "",
            class: "userName"
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (!userAvatar.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dropdown, {
        size: "large",
        onCommand: handleUser
      }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, { command: "user" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(EditPen), { class: "icon__setting" }),
                  _createTextVNode(_toDisplayString(_ctx.$t('header.AccountInformation')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_dropdown_item, {
                divided: "",
                command: "outLogin"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Back), { class: "icon__setting" }),
                  _createTextVNode(_toDisplayString(_ctx.$t('header.LogOut')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createTextVNode(_toDisplayString(userName.value) + " ", 1),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_unref(ArrowDown))
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(messageListDrawer, {
      ref_key: "messageListDrawerRef",
      ref: messageListDrawerRef,
      getMessageList: getMessageList
    }, null, 512)
  ], 64))
}
}

})